import React from 'react'
import { Carousel } from "react-bootstrap";
import { FaArrowCircleUp, FaCoins, FaRegSmile } from 'react-icons/fa';
import { Link } from "react-router-dom";
import Networks from '../images/networkss.png'
import line from '../images/line.png'
import Vtu from '../images/vtu.png'
import Vas2 from '../images/vas2.png'
import Mobile from '../images/9mobile.jpeg';
import Dstv from '../images/dstv.jpeg'
import Gotv from '../images/gotv.png';
import Card from '../images/card.png';
import Data from '../images/data.png';
import Waec2 from '../images/waec_neco.jpeg';
import Data1 from '../images/data1.png';
import Startimes from '../images/startimes.jpeg';
import mtncyc from '../images/mtn-cyc.png';
import airtelcyc from '../images/airtel-cyc.png';
import glocyc from '../images/glo-cyc.png';
import mobilecyc from '../images/9mobilecyc.png';
import Electric from '../images/electric.jpg';
import Waec from "../images/waec.png";
import AppsNtk from '../images/AppsNtk.png'
import MobileData from '../images/mobile_data.png'
import Interswitch from '../images/interswitch.png'
import line2 from '../images/line2.png'
import MyButton from '../components/MyButton'
import Network2 from '../images/network2.png'
import network3 from '../images/network3.png'
import Together from '../images/wktogether.png'
import Illustration from '../images/Illustration.png'
import circleIcon from '../images/Avatar.png'
import topIcon from '../images/Quote.png'
import ServiceCards from '../components/ServiceCards';
import ServiceCard from '../components/ServiceCard'
import checkBox from '../images/checkbox.png'
import ClientCard from '../components/ClientCard';
import Footer from '../components/Footer';


const Home = () => {
    return (
        <div className="main-ct">
            <div className='home-sect'>
                <div className='sect-1 sect-1-laptop'>
                    <div className='sect-ntk'>
                        <div className='sect-ntk1 ntk1-tablet'>
                            <div className="overlay-bg-content">
                                <h1 className="data-plan-main">1GB</h1>
                                <h3 className="data-plan-sub">30 days</h3>
                                <div className="price-wrapper">
                                    <small className="price-label">Now at</small>
                                    <span className="price-tag">₦249</span>
                                </div>
                                <Link to="/dashboard" className="my-cstm-btn-link">
                                    <button className="get-btn">Get Yours</button>
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className='sect-head'>
                            <h4>Buy/Resell Cheap Data & Airtime | Electricity Bills Payment | Cable TV Subscription | Convert Airtime to Cash</h4>
                        </div>
                        <div className="topup-features-container">
                            {/* First Feature */}
                            <div className="topup-feature">
                                <div className="feature-icon">
                                    <FaArrowCircleUp />
                                </div>
                                <div className="feature-text">
                                    <h5>INSTANT TOPUP</h5>
                                    <p>Our delivery is automated and at a breeze</p>
                                </div>
                            </div>

                            {/* Second Feature */}
                            <div className="topup-feature">
                                <div className="feature-icon">
                                    <FaCoins />
                                </div>
                                <div className="feature-text">
                                    <h5>MONEY BACK GUARANTEE</h5>
                                    <p>Didn't get value? We will refund you 100%</p>
                                </div>
                            </div>

                            {/* Third Feature */}
                            <div className="topup-feature">
                                <div className="feature-icon">
                                    <FaRegSmile />
                                </div>
                                <div className="feature-text">
                                    <h5>24/7 QUALITY SUPPORT</h5>
                                    <p>Get in touch via phone email and live chat</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="body-sect body-sect-laptop">
                <div className='sect-2-laptop sect-2-mobile'>
                    <ServiceCards />
                </div>

            </div>

            <div className='body2-sect'>
                <div className='sect-3-laptop sect-2-mobile'>
                    <div className="sect-flex-lg">
                        <div className='sect-ntk'>
                            <div className='sect-ntk2 ntk2-tablet'>

                            </div>
                        </div>
                        <div className='data-clip dc2-tablet'>
                            <div className="data-mgt">
                                <h4>Pay Electricity</h4>
                            </div>
                            <div className="data-txt">
                                <p>Pay your electricity bills seamlessly with SubnetExpress. Get instant token delivery for AEDC, EKEDC, IBEDC, IKEDC, JED, KAEDCO, KEDCO, PHED, and more.</p>
                                <p>Enjoy fast, reliable, and stress-free power payments from the comfort of your home.</p>
                            </div>
                            <div className='body-sect-btn sect-btn sect-btn-laptop'>
                                <Link to="/dashboard" className="my-cstm-btn-link">
                                    <MyButton text="Get Started" faicon="fa-arrow-right" />
                                </Link>
                            </div>
                        </div>
                    </div>

                </div>
            </div>


            <div className='home-sect body3-sect'>
                <div className='sect-4-laptop sect-4-mobile'>
                    <div className="sect-flex-lg lg-reverse">
                        <div className='sect-ntk'>
                            <div className='sect-ntk3 ntk3-tablet'>

                            </div>
                        </div>
                        <div className='data-clip dc2-tablet'>
                            <div className="data-mgt">
                                <h4>Print Recharge Cards</h4>
                            </div>
                            <div className="data-txt">
                                <p>Easily print recharge cards for all networks including MTN, Glo, Airtel, and 9Mobile using SubnetExpress VTU platform.</p>
                                <p>Download and print pins directly from your dashboard — fast, reliable, and perfect for resellers.</p>
                            </div>
                            <div className='body-sect-btn sect-btn sect-btn-laptop'>
                                <Link to="/dashboard" className="my-cstm-btn-link">
                                    <MyButton text="Get Started" faicon="fa-arrow-right" />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="body-sect body-sect-laptop">
                <div className='sect-2-laptop sect-2-mobile'>

                    <ServiceCard />
                </div>

            </div>


            <div className="home-sect body4-sect">
                <div className="sect-6-laptop sect-2-mobile">
                    <div className="data-clip dc5-tablet">
                        <div className="data-mgt">
                            <h4>Affordable Data Plans</h4>
                        </div>
                    </div>
                    <div className="data-description">
                        <p>Choose from a variety of affordable data plans across networks like MTN, Glo, Airtel, and 9Mobile. Stay connected with the best plans that suit your needs and budget.</p>
                    </div>

                    <div className="plans-container">
                        <div className="plans">
                            {/* MTN Data Plan */}
                            <div className="data-plan-card">
                                <img src={mtncyc} alt="mtn" className="img-small" />
                                <h5>MTN Data</h5>
                                <p>75MB - ₦80 (Daily)</p>
                                <p>1GB - ₦490 (Daily)</p>
                                <p>1.5GB - ₦972 (Weekly)</p>
                                <p>3.5GB - ₦1470 (Weekly)</p>
                                <p>6GB - ₦2430 (Weekly)</p>
                                <p>500MB - ₦420 (Monthly)</p>
                                <p>2.5GB - ₦875 (Daily)</p>
                                <p>3GB - ₦2000 (Monthly)</p>
                                <p>5GB - ₦2800 (Monthly)</p>
                                <p>7GB - ₦3400 (Monthly)</p>
                                <p>12.5GB - ₦5320 (Monthly)</p>
                                <p>20GB - ₦4950 (Monthly)</p>
                                <Link to="/dashboard" className="my-cstm-btn-link">
                                    <button className="pricing-btn">Order Now</button>
                                </Link>
                            </div>

                            {/* Glo Data Plan */}
                            <div className="data-plan-card">
                                <img src={glocyc} alt="glo" className="img-small" />
                                <h5>Glo Data</h5>
                                <p>200MB - ₦110 (Weekly)</p>
                                <p>500MB - ₦210 (Monthly)</p>
                                <p>1GB - ₦410 (Monthly)</p>
                                <p>2GB - ₦820 (Monthly)</p>
                                <p>3GB - ₦1215 (Monthly)</p>
                                <p>5GB - ₦2025 (Monthly)</p>
                                <p>10GB - ₦4050 (Monthly)</p>
                                <p>15GB - ₦5200 (Monthly)</p>
                                <p>20GB - ₦6200 (Monthly)</p>
                                <p>30GB - ₦9000 (Monthly)</p>
                                <p>50GB - ₦12000 (Monthly)</p>
                                <p>100GB - ₦20000 (Monthly)</p>
                                <Link to="/dashboard" className="my-cstm-btn-link">
                                    <button className="pricing-btn">Order Now</button>
                                </Link>
                            </div>

                            {/* Airtel Data Plan */}
                            <div className="data-plan-card">
                                <img src={airtelcyc} alt="airtel" className="img-small" />
                                <h5>Airtel Data</h5>
                                <p>150MB - ₦75 (2 Days)</p>
                                <p>600MB - ₦270 (Daily)</p>
                                <p>1.5GB - ₦410 (Daily)</p>
                                <p>2GB - ₦530 (2 Days)</p>
                                <p>4GB - ₦800 (2 Days)</p>
                                <p>1.5GB - ₦990 (Weekly)</p>
                                <p>3.5GB - ₦1480 (Weekly)</p>
                                <p>6GB - ₦2450 (Weekly)</p>
                                <p>7GB - ₦2150 (Weekly)</p>
                                <p>10GB - ₦2950 (Weekly)</p>
                                <p>3GB - ₦1960 (Monthly)</p>
                                <p>8GB - ₦2950 (Monthly)</p>
                                <Link to="/dashboard" className="my-cstm-btn-link">
                                    <button className="pricing-btn">Order Now</button>
                                </Link>
                            </div>

                            {/* 9Mobile Data Plan */}
                            <div className="data-plan-card">
                                <img src={mobilecyc} alt="9mobile" className="img-small" />
                                <h5>9Mobile Data</h5>
                                <p>500MB - ₦200 (Daily)</p>
                                <p>1GB - ₦300 (Daily)</p>
                                <p>1.5GB - ₦500 (Weekly)</p>
                                <p>2GB - ₦700 (Weekly)</p>
                                <p>3GB - ₦1000 (Weekly)</p>
                                <p>4.5GB - ₦1200 (Monthly)</p>
                                <p>10GB - ₦2500 (Monthly)</p>
                                <p>15GB - ₦3500 (Monthly)</p>
                                <p>20GB - ₦4500 (Monthly)</p>
                                <p>40GB - ₦8000 (Monthly)</p>
                                <p>75GB - ₦15000 (Monthly)</p>
                                <p>120GB - ₦20000 (Monthly)</p>
                                <Link to="/dashboard" className="my-cstm-btn-link">
                                    <button className="pricing-btn">Order Now</button>
                                </Link>
                            </div>
                        </div>
                    </div>

                    {/* Carousel for mobile and tablet */}
                    <div className="plans-carousel-container">
                        <div className="plans-carousel">
                            <Carousel interval={3000} indicators={true} controls={false}>
                                {/* MTN Data Plan */}
                                <Carousel.Item>
                                    <div className="data-plan-card">
                                        <img src={mtncyc} alt="mtn" className="img-small" />
                                        <h5>MTN Data</h5>
                                        <h5>MTN Data</h5>
                                        <p>75MB - ₦80 (Daily)</p>
                                        <p>1GB - ₦490 (Daily)</p>
                                        <p>1.5GB - ₦972 (Weekly)</p>
                                        <p>3.5GB - ₦1470 (Weekly)</p>
                                        <p>6GB - ₦2430 (Weekly)</p>
                                        <p>500MB - ₦420 (Monthly)</p>
                                        <p>2.5GB - ₦875 (Daily)</p>
                                        <p>3GB - ₦2000 (Monthly)</p>
                                        <p>5GB - ₦2800 (Monthly)</p>
                                        <p>7GB - ₦3400 (Monthly)</p>
                                        <p>12.5GB - ₦5320 (Monthly)</p>
                                        <p>20GB - ₦4950 (Monthly)</p>
                                        <Link to="/dashboard" className="my-cstm-btn-link">
                                            <button className="pricing-btn">Order Now</button>
                                        </Link>
                                    </div>
                                </Carousel.Item>

                                {/* Glo Data Plan */}
                                <Carousel.Item>
                                    <div className="data-plan-card">
                                        <img src={glocyc} alt="glo" className="img-small" />
                                        <h5>Glo Data</h5>
                                        <p>200MB - ₦110 (Weekly)</p>
                                        <p>500MB - ₦210 (Monthly)</p>
                                        <p>1GB - ₦410 (Monthly)</p>
                                        <p>2GB - ₦820 (Monthly)</p>
                                        <p>3GB - ₦1215 (Monthly)</p>
                                        <p>5GB - ₦2025 (Monthly)</p>
                                        <p>10GB - ₦4050 (Monthly)</p>
                                        <p>15GB - ₦5200 (Monthly)</p>
                                        <p>20GB - ₦6200 (Monthly)</p>
                                        <p>30GB - ₦9000 (Monthly)</p>
                                        <p>50GB - ₦12000 (Monthly)</p>
                                        <p>100GB - ₦20000 (Monthly)</p>
                                        <Link to="/dashboard" className="my-cstm-btn-link">
                                            <button className="pricing-btn">Order Now</button>
                                        </Link>
                                    </div>
                                </Carousel.Item>

                                {/* Airtel Data Plan */}
                                <Carousel.Item>
                                    <div className="data-plan-card">
                                        <img src={airtelcyc} alt="airtel" className="img-small" />
                                        <h5>Airtel Data</h5>
                                        <p>150MB - ₦75 (2 Days)</p>
                                        <p>600MB - ₦270 (Daily)</p>
                                        <p>1.5GB - ₦410 (Daily)</p>
                                        <p>2GB - ₦530 (2 Days)</p>
                                        <p>4GB - ₦800 (2 Days)</p>
                                        <p>1.5GB - ₦990 (Weekly)</p>
                                        <p>3.5GB - ₦1480 (Weekly)</p>
                                        <p>6GB - ₦2450 (Weekly)</p>
                                        <p>7GB - ₦2150 (Weekly)</p>
                                        <p>10GB - ₦2950 (Weekly)</p>
                                        <p>3GB - ₦1960 (Monthly)</p>
                                        <p>8GB - ₦2950 (Monthly)</p>
                                        <Link to="/dashboard" className="my-cstm-btn-link">
                                            <button className="pricing-btn">Order Now</button>
                                        </Link>
                                    </div>
                                </Carousel.Item>

                                {/* 9Mobile Data Plan */}
                                <Carousel.Item>
                                    <div className="data-plan-card">
                                        <img src={mobilecyc} alt="mtn" className="img-small" />
                                        <h5>9Mobile Data</h5>
                                        <p>500MB - ₦200 (Daily)</p>
                                        <p>1GB - ₦300 (Daily)</p>
                                        <p>1.5GB - ₦500 (Weekly)</p>
                                        <p>2GB - ₦700 (Weekly)</p>
                                        <p>3GB - ₦1000 (Weekly)</p>
                                        <p>4.5GB - ₦1200 (Monthly)</p>
                                        <p>10GB - ₦2500 (Monthly)</p>
                                        <p>15GB - ₦3500 (Monthly)</p>
                                        <p>20GB - ₦4500 (Monthly)</p>
                                        <p>40GB - ₦8000 (Monthly)</p>
                                        <p>75GB - ₦15000 (Monthly)</p>
                                        <p>120GB - ₦20000 (Monthly)</p>
                                        <Link to="/dashboard" className="my-cstm-btn-link">
                                            <button className="pricing-btn">Order Now</button>
                                        </Link>
                                    </div>
                                </Carousel.Item>
                            </Carousel>
                        </div>
                    </div>
                </div>
            </div>


            <div className="home-sect body6-sect">
                <div className="sect-9-laptop">
                    <div className="data-clip dc7-tablet">
                        <div className="data-mgt sponz">
                            <h4>Our Sponsors</h4>
                        </div>
                    </div>

                    {/* Slider container */}
                    <div className="sponsor-slider-wrapper">
                        <div className="sponsor-slider-track">
                            {[Vtu, Mobile, Dstv, Startimes, Gotv, Electric, Waec, Interswitch, Vas2, MobileData, Vtu, , Mobile, Dstv, Startimes, Gotv, Electric, Waec, Interswitch, Vas2, MobileData].map((imgSrc, idx) => (
                                <div className="sponsor-slide" key={idx}>
                                    <img src={imgSrc} alt="sponsor-logo" />
                                </div>
                            ))}
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default Home;